export default "__VITE_ASSET__gFJEXKSc__"